export default {
  FEEDS: "Feeds",
  FEED: "Feed",
};
